/* unplugin-vue-components disabled */import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useConfigurationStore } from '@/stores/configurationModule';
export default {
  __name: 'EditorMask',
  props: {
    printSide: {
      type: String,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const editorMask = ref(null);
    const configuratorStore = useConfigurationStore();
    const {
      box
    } = storeToRefs(configuratorStore);
    const svgElement = ref(null);
    onMounted(() => {
      const mask = box.value.get2DEditorSvg(props.printSide);
      const svgParser = new DOMParser();
      const svgDoc = svgParser.parseFromString(mask, 'image/svg+xml');
      svgElement.value = svgDoc.documentElement;
      if (editorMask.value) {
        editorMask.value.appendChild(svgElement.value);
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "editorMask",
        ref_key: "editorMask",
        ref: editorMask
      }, null, 512);
    };
  }
};